<template>
  <mdb-footer color="dark" class="font-small pt-4">
    <mdb-container class="text-left">
      <mdb-row>
        <mdb-col sm="6">
          <h5 class="text-uppercase h5-responsive">
            Made with
            <i class="fa fa-heart"></i> in Germany.
          </h5>
        </mdb-col>
        <mdb-col sm="3">
          <ul class="list-unstyled">
            <li class="list-unstyled">
              <a href="privacy-policy">Privacy policy</a>
            </li>
            <li class="list-unstyled">
              <a href="/imprint">Legal details</a>
            </li>
          </ul>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div class="footer-copyright text-center py-3">
      <mdb-container fluid>
        &copy; 2020 Copyright:
        <a href="https://virallyze.com">virallyze.com</a>
      </mdb-container>
    </div>
  </mdb-footer>
</template>

<script>
import { mdbFooter, mdbContainer, mdbRow, mdbCol } from "mdbvue";
export default {
  name: "Footer",
  components: {
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>
